import React, { ReactElement, useContext } from 'react';
import { SSRApiContext } from '@ecommerce/nest-ssr/common';

import type { CompanyInterface } from 'interfaces/company.interface';
import Link from 'atomic/link/link';

const CompanyViewCategories: React.FC<{ company: CompanyInterface; }> = ({ company }): ReactElement | null => {
    if (!company.category?.length) {
        return null;
    }

    const api = useContext(SSRApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';
    const categories = company.category
        ?.map((item, index): ReactElement => (
            <React.Fragment key={item.slug}>
                {index
                    ? (
                        <span className="company-view-header__categories-separator">
                            |
                        </span>
                    )
                    : ''}
                {' '}
                <Link href={`${company.type === 'shop' ? '' : '/firmy'}/${item.slug}.html`} className="company-view-header__categories-list-item">
                    {item.name}
                </Link>
            </React.Fragment>
        ));

    return (
        <div className="company-view-header__categories">
            {isMobile || 'Kategorie: '}
            <span className="company-view-header__categories-list">
                {categories}
            </span>
        </div>
    );
};

export default CompanyViewCategories;
